import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDismiss = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8 1.00006C4.13438 1.00006 1 4.13444 1 8.00006C1 11.8657 4.13438 15.0001 8 15.0001C11.8656 15.0001 15 11.8657 15 8.00006C15 4.13444 11.8656 1.00006 8 1.00006ZM8 13.8126C4.79063 13.8126 2.1875 11.2094 2.1875 8.00006C2.1875 6.60944 2.67656 5.33131 3.49219 4.33131L11.6687 12.5079C10.6687 13.3235 9.39062 13.8126 8 13.8126ZM12.5078 11.6688L4.33125 3.49225C5.33125 2.67662 6.60938 2.18756 8 2.18756C11.2094 2.18756 13.8125 4.79069 13.8125 8.00006C13.8125 9.39069 13.3234 10.6688 12.5078 11.6688Z",
		fill: "#8C8C8C"
	})]
});
const ForwardRef = forwardRef(SvgDismiss);
export { ForwardRef as ReactComponent };
